var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 17,
    viewBox: "0 0 190 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.333333 8.5C0.333333 9.97276 1.52724 11.1667 3 11.1667C4.47276 11.1667 5.66667 9.97276 5.66667 8.5C5.66667 7.02724 4.47276 5.83333 3 5.83333C1.52724 5.83333 0.333333 7.02724 0.333333 8.5ZM189.354 8.85355C189.549 8.65829 189.549 8.34171 189.354 8.14645L186.172 4.96447C185.976 4.7692 185.66 4.7692 185.464 4.96447C185.269 5.15973 185.269 5.47631 185.464 5.67157L188.293 8.5L185.464 11.3284C185.269 11.5237 185.269 11.8403 185.464 12.0355C185.66 12.2308 185.976 12.2308 186.172 12.0355L189.354 8.85355ZM3 9H5.02174V8H3V9ZM9.06522 9H13.1087V8H9.06522V9ZM17.1522 9H21.1957V8H17.1522V9ZM25.2391 9H29.2826V8H25.2391V9ZM33.3261 9H37.3696V8H33.3261V9ZM41.413 9H45.4565V8H41.413V9ZM49.5 9H53.5435V8H49.5V9ZM57.587 9H61.6304V8H57.587V9ZM65.6739 9H69.7174V8H65.6739V9ZM73.7609 9H77.8044V8H73.7609V9ZM81.8478 9H85.8913V8H81.8478V9ZM89.9348 9H93.9783V8H89.9348V9ZM98.0218 9H102.065V8H98.0218V9ZM106.109 9H110.152V8H106.109V9ZM114.196 9H118.239V8H114.196V9ZM122.283 9H126.326V8H122.283V9ZM130.37 9H134.413V8H130.37V9ZM138.457 9H142.5V8H138.457V9ZM146.543 9H150.587V8H146.543V9ZM154.63 9H158.674V8H154.63V9ZM162.717 9H166.761V8H162.717V9ZM170.804 9H174.848V8H170.804V9ZM178.891 9H182.935V8H178.891V9ZM186.978 9H189V8H186.978V9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4 9.7C100.267 9.7 104 9.7 104 8.5C104 7.3 98.4 7.3 98.4 7.3L94 0.5L92.8 0.9L94.8 7.3L90.4 7.7L88.8 5.3L88 5.7L88.8 8.5L88 11.3L88.8 11.7L90.4 9.3L94.8 9.7L92.8 16.1L94 16.5L98.4 9.7Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirline);
export default __webpack_public_path__ + "static/media/airline.469ee21de3627eecb7f33ac300c514ea.svg";
export { ForwardRef as ReactComponent };